module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Bold.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Bold.woff
 ** module id = 1095
 ** module chunks = 0
 **/